import React, { useState, useEffect, useRef } from 'react';
import {
  Table,
  Spin,
  Button,
  Drawer,
  List,
  Modal,
  Checkbox,
  Input,
  Select,
  Form,
  InputNumber,
  message,
} from 'antd';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { arrayMoveImmutable as arrayMove } from 'array-move';
import { useSelector } from 'react-redux';
import AxiosOICStat from 'AxiosOICStat';
import PdfOptionsModal from 'components/modals/PdfOptionsModal';
import CoverPageModal from 'components/modals/CoverPageModal';
import ScheduleReportModal from 'components/modals/ScheduleReportModal';
import { getIndicatorName } from '../utils/indicatorName';

const { Option } = Select;

const DragHandle = SortableHandle(() => (
  <span style={{ cursor: 'grab', color: '#999' }}>≡</span>
));

const SortableItem = SortableElement((props) => <tr {...props} />);
const SortableBody = SortableContainer((props) => <tbody {...props} />);

function GenerateReport() {
  const [pdfOptionsForm] = Form.useForm();
  const indicatorsState = useSelector((state) => state.indicators);
  const categoriesState = useSelector((state) => state.categories);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [orderData, setOrderData] = useState([]);
  const orderDataRef = useRef(orderData);
  orderDataRef.current = orderData;

  const [modalVisible, setModalVisible] = useState(false);
  const [generateWholeReportModalVisible, setGenerateWholeReportModalVisible] = useState(false);
  const [generateTOC, setGenerateTOC] = useState(false);
  const [generateLOT, setGenerateLOT] = useState(false);

  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");

  const [footerText, setFooterText] = useState("");
  const [footerFontSize, setFooterFontSize] = useState("");
  const [headerTextForTOC, setHeaderTextForTOC] = useState("");
  const [headerTextForLOT, setHeaderTextForLOT] = useState("");
  const [alignment, setAlignment] = useState("");
  const [indentationMargin, setIndentationMargin] = useState("");
  const [fontFamily, setFontFamily] = useState("");
  const [colorForTocLot, setColorForTocLot] = useState("");
  const [pdfOptionsModalVisible, setPdfOptionsModalVisible] = useState(false);
  const[isScheduleModalVisible, setIsScheduleModalVisible] = useState(false);
  const [isWholeReportGenerated, setIsWholeReportGenerated] = useState(false);
  const [isAllTablesGenerated, setIsAllTablesGenerated] = useState(false);
  const [isLoadingForGenerateWholeReport, setIsLoadingForGenerateWholeReport] = useState(false);
  const [isLodingForGenerateAllTables, setIsLoadingForGenerateAllTables] = useState(false);
  const [exportType, setExportType] = useState("pdf");
  const [generateWholeReportExportType, setGenerateWholeReportExportType] = useState("pdf");
  const [isCoverPageModalVisible, setIsCoverPageModalVisible] = useState(false);
  const [wholeReportRequest, setWholeReportRequest] = useState([]);

  const [isCategoryReportMode, setIsCategoryReportMode] = useState(false);
  const [selectedCategoryCodes, setSelectedCategoryCodes] = useState([]);
  const [isCategoryReportLoading, setIsCategoryReportLoading] = useState(false);

  const handleGenerateWholeReport = (values) => {
    if (values.schedule) {
      setIsScheduleModalVisible(true);
    } else {
      handleGenerateWholeReportNow(values);
    }
  };

  const handleGenerateWholeReportLater = (values) => {
    values.scheduleTime = String(values.scheduleTime);
    wholeReportRequest.scheduleTime = String(values.scheduleTime);
    wholeReportRequest.email = String(values.email);
    if (orderData.length === 0) {
      message.error("Please select the order of the tables first and click get order button");
      return;
    }
    const payload = {
      orderData,
      wholeReportRequest,
    };

    console.log("Schedule Report Payload:", payload);
    AxiosOICStat.post('/syb/schedule_report/', payload)
      .then((response) => {
        console.log("Schedule Report Response:", response.data);
        message.success("Report scheduled successfully.");
        setIsScheduleModalVisible(false);
      })
      .catch((error) => {
        console.error("Error scheduling report:", error);
        message.error("Error scheduling report.");
        setIsScheduleModalVisible(false);
      });
  };
   
  const handleGenerateWholeReportNow = (values) => {
    console.log("Generate Whole Report Values:", values);
    if (orderData.length === 0) {
      message.error("Please select the order of the tables first and click get order button");
      return;
    }
    setIsLoadingForGenerateWholeReport(true);
    const payload = {
      orderData,
      values,
    };
    console.log("Generate Whole Report Payload:", payload);
    AxiosOICStat.post('/syb/generate_whole_report_docx/', payload, {
      responseType: 'blob',
    })
      .then((response) => {
        const file = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = 'SYB.docx'; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoadingForGenerateWholeReport(false);
        setGenerateWholeReportModalVisible(false);
      })
      .catch((error) => {
        console.error('Error generating whole report DOCX:', error);
        setIsLoadingForGenerateWholeReport(false);
      });
  };
  
  const handleGenerateAllTables = (values) => {
    if(orderData.length === 0) {
        message.error("Please select the order of the tables first and click get order button");
        return;
    }
    setIsLoadingForGenerateAllTables(true);
    var is_cover_page_needed = false;
    if(exportType === 'pdf') {
      is_cover_page_needed = true;
    }
    else if(exportType === 'word') {
      is_cover_page_needed = false;
    }
    const payload = {
      orderData,
      ...values,
      is_cover_page_needed
    };

    if(exportType === 'pdf') {
      AxiosOICStat.post('/syb/generate_all_tables/', payload, {
        responseType: 'blob',
      })
        .then((response) => {
          const file = new Blob([response.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          setPreviewUrl(fileURL);
          setIsLoadingForGenerateAllTables(false);
          setPreviewModalVisible(true);
          setPdfOptionsModalVisible(false);
        })
        .catch((error) => {
          console.error('Error generating all tables PDF:', error);
        });
    }

    else if(exportType === 'word') {
      AxiosOICStat.post('/syb/generate_all_tables_word/', payload, {
        responseType: 'blob',
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'All_Indicators.docx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setPreviewUrl(url);
        setIsLoadingForGenerateAllTables(false);
        setPdfOptionsModalVisible(false);
      })
      .catch((error) => {
        console.error('Error generating all tables Word:', error);
      });
    }
    

    else{
      message.error("Please select a valid export type");
    }
    

    setModalVisible(false);
  };

  const handleCategoryReportSubmit = async (formValues) => {
    if (selectedCategoryCodes.length === 0) {
      message.error("Please select at least one category");
      return;
    }
    setIsCategoryReportLoading(true);
    try {
      const filteredOrderData = orderData.filter(cat =>
        selectedCategoryCodes.includes(cat.categoryCode)
      );
      if (filteredOrderData.length === 0) {
        message.error("No matching categories found in order data");
        setIsCategoryReportLoading(false);
        return;
      }
      const payload = {
        orderData: filteredOrderData,
        ...formValues,
        is_cover_page_needed: false,
      };
      const response = await AxiosOICStat.post('/syb/generate_all_tables_word/', payload, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const catNames = selectedCategoryCodes
        .map(code => categories.find(c => c.categoryCode === code)?.categoryName || `Cat${code}`)
        .join('_');
      link.download = `${catNames}.docx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      message.success("Category report generated successfully!");
      setPdfOptionsModalVisible(false);
      setIsCategoryReportMode(false);
      setSelectedCategoryCodes([]);
    } catch (error) {
      const errMsg = error.response?.data?.detail || error.message || "Failed to generate category report";
      message.error(errMsg);
      console.error("Error generating category report:", error);
    } finally {
      setIsCategoryReportLoading(false);
      setExportType('word');
    }
  };

  useEffect(() => {
    getTableOrder();
  }, []);
  

  useEffect(() => {
    AxiosOICStat.get('/syb/syb_categories/')
      .then((response) => {
        const categoryMap = {};
        response.data.forEach(([categoryCode, indicatorCode]) => {
          if (!categoryMap[categoryCode]) {
            categoryMap[categoryCode] = {
              categoryCode,
              categoryName:
                categoriesState.value[categoryCode]?.cat_name_eng ||
                `Category ${categoryCode}`,
              indicators: [],
            };
          }
          categoryMap[categoryCode].indicators.push({
            indicatorCode,
            indicatorName:
              getIndicatorName(indicatorsState.value[indicatorCode]) ||
              `Indicator ${indicatorCode}`,
          });
        });
        const categoriesArray = Object.values(categoryMap);
        setCategories(reorderCategories(categoriesArray, orderDataRef.current));
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching categories:', error);
        setLoading(false);
      });
  }, [categoriesState, indicatorsState]);

  const onSortCategoriesEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      setCategories((prev) => arrayMove(prev, oldIndex, newIndex));
    }
  };

  const DraggableCategoryBody = (props) => (
    <SortableBody
      useDragHandle
      disableAutoscroll
      helperClass="row-dragging"
      onSortEnd={onSortCategoriesEnd}
      {...props}
    />
  );

  const DraggableCategoryRow = ({ className, style, ...restProps }) => {
    const index = categories.findIndex(
      (cat) => `cat_${cat.categoryCode}` === restProps['data-row-key']
    );
    return <SortableItem index={index} {...restProps} />;
  };

  const ExpandedRowTable = ({ indicators, categoryIndex }) => {
    const [localIndicators, setLocalIndicators] = useState(indicators);

    useEffect(() => {
      setLocalIndicators(indicators);
    }, [indicators]);

    const onSortIndicatorsEnd = ({ oldIndex, newIndex }) => {
      if (oldIndex !== newIndex) {
        const newIndicators = arrayMove(localIndicators, oldIndex, newIndex);
        setLocalIndicators(newIndicators);
        setCategories((prev) => {
          const updated = [...prev];
          updated[categoryIndex] = {
            ...updated[categoryIndex],
            indicators: newIndicators,
          };
          return updated;
        });
      }
    };

    const DraggableIndicatorBody = (props) => (
      <SortableBody
        useDragHandle
        disableAutoscroll
        helperClass="row-dragging"
        onSortEnd={onSortIndicatorsEnd}
        {...props}
      />
    );

    const DraggableIndicatorRow = ({ className, style, ...restProps }) => {
      const index = localIndicators.findIndex(
        (ind) => `ind_${ind.indicatorCode}` === restProps['data-row-key']
      );
      return <SortableItem index={index} {...restProps} />;
    };

    const indicatorColumns = [
      {
        title: '',
        dataIndex: 'sort',
        width: 30,
        render: () => <DragHandle />,
      },
      {
        title: '',
        dataIndex: 'indicatorName',
      },
    ];

    const indicatorDataSource = localIndicators.map((ind) => ({
      key: `ind_${ind.indicatorCode}`,
      ...ind,
    }));

    return (
      <Table
        columns={indicatorColumns}
        dataSource={indicatorDataSource}
        pagination={false}
        rowKey="key"
        components={{
          body: {
            wrapper: DraggableIndicatorBody,
            row: DraggableIndicatorRow,
          },
        }}
      />
    );
  };

  const categoryColumns = [
    {
      title: '',
      dataIndex: 'sort',
      width: 30,
      render: () => <DragHandle />,
    },
    {
      title: 'Category',
      dataIndex: 'categoryName',
      render: (text) => <strong>{text}</strong>,
    },
  ];

  const categoryDataSource = categories.map((cat, catIndex) => ({
    key: `cat_${cat.categoryCode}`,
    ...cat,
  }));

  const reorderCategories = (categories, orderData) => {
    const orderMap = {};
    orderData.forEach((ord) => {
      orderMap[ord.categoryCode] = ord;
    });

    const sortedCategories = [...categories].sort((a, b) => {
      const orderA = orderMap[a.categoryCode]?.order || '0';
      const orderB = orderMap[b.categoryCode]?.order || '0';
      return parseFloat(orderA) - parseFloat(orderB);
    });

    sortedCategories.forEach((cat) => {
      const ordCat = orderMap[cat.categoryCode];
      if (ordCat && ordCat.indicators) {
        const indicatorOrderMap = {};
        ordCat.indicators.forEach((ind) => {
          indicatorOrderMap[ind.indicatorCode] = ind.order;
        });
        cat.indicators.sort((indA, indB) => {
          const orderA = indicatorOrderMap[indA.indicatorCode] || '0';
          const orderB = indicatorOrderMap[indB.indicatorCode] || '0';
          return parseFloat(orderA) - parseFloat(orderB);
        });
      }
    });
    return sortedCategories;
  };

  const getTableOrder = () => {
    AxiosOICStat.get('/syb/order-data')
      .then((response) => {
        const orderDataFromEndpoint = response.data.orderData
          ? response.data.orderData
          : response.data;
        setOrderData(orderDataFromEndpoint);
        setCategories(prev => reorderCategories(prev, orderDataFromEndpoint));
        //message.info('Retrieved updated order data.');
      })
      .catch((error) => {
        message.error('Error retrieving order data.');
        console.error('Error retrieving order data:', error);
      });
  };

  const handleGetCoverPage = (values) => {
    const payload = {
      cat_code: values.category,
      format: values.exportType,
    };
    
    AxiosOICStat.post('/syb/get_cover_page/', payload, {
      responseType: 'blob', // Always request a blob
    })
      .then((response) => {
        // response.data is already a Blob
        const file = response.data;
        const fileURL = URL.createObjectURL(file);
        
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = payload.format === 'pdf' ? 'cover_page.pdf' : 'cover_page.docx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    
        setIsCoverPageModalVisible(false);
      })
      .catch((error) => {
        console.error('Error generating cover page:', error);
      });
  };
  
  

  return (
    <>
      <style>{`
        .row-dragging {
          font-family: inherit;
          font-size: inherit;
          color: inherit;
          background: #fafafa;
        }
      `}</style>
      {loading ? (
        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Spin tip="Loading..." />
        </div>
      ) : (
        <>
          <Button
            onClick={() => {
              setIsCategoryReportMode(false);
              setPdfOptionsModalVisible(true);
              setIsWholeReportGenerated(false);
              setIsAllTablesGenerated(true);
            }}
            style={{ marginBottom: 16, marginRight: 16 }}
          >
            Generate All Tables
          </Button>
          <Select
            mode="multiple"
            placeholder="Select categories"
            style={{ minWidth: 250, marginRight: 8, marginBottom: 16 }}
            value={selectedCategoryCodes}
            onChange={setSelectedCategoryCodes}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label || '').toLowerCase().includes(input.toLowerCase())
            }
            options={(() => {
              // Build a lookup from categories state
              const catLookup = {};
              categories.forEach(c => { catLookup[c.categoryCode] = c.categoryName; });
              // Sort by orderData order first, then append any extras
              const ordered = (orderData || [])
                .filter(od => catLookup[od.categoryCode])
                .map(od => ({
                  value: od.categoryCode,
                  label: `${od.categoryName || catLookup[od.categoryCode]} (${od.categoryCode})`
                }));
              const seen = new Set(ordered.map(o => o.value));
              const extras = categories
                .filter(c => !seen.has(c.categoryCode))
                .map(c => ({
                  value: c.categoryCode,
                  label: `${c.categoryName} (${c.categoryCode})`
                }));
              return [...ordered, ...extras];
            })()}
          />
          <Button
            type="primary"
            disabled={selectedCategoryCodes.length === 0}
            onClick={() => {
              setIsCategoryReportMode(true);
              setExportType('word');
              setPdfOptionsModalVisible(true);
            }}
            style={{ marginBottom: 16, marginRight: 16 }}
          >
            Generate Category Tables
          </Button>
          <Button
            onClick={() => {
              setIsCoverPageModalVisible(true);
              setIsWholeReportGenerated(false);
              setIsAllTablesGenerated(false);
              setGenerateTOC(false);
              setGenerateLOT(false);
              setFooterText("");
            }}
            style={{ marginBottom: 16, marginRight: 16 }}
          >
            Get Cover Page
          </Button>
          <Button
            onClick={() => {
              setGenerateWholeReportModalVisible(true);
              setIsWholeReportGenerated(true);
              setIsAllTablesGenerated(false);
            }}
            style={{ marginBottom: 16, marginRight: 16, display: 'none' }}
          >
            Generate Whole Report
          </Button>
          <Button onClick={() => setDrawerVisible(true) } style={{ marginBottom: 16 }}>
            Get Order
          </Button>
          <Table
            columns={categoryColumns}
            dataSource={categoryDataSource}
            pagination={false}
            rowKey="key"
            style={{display: 'none'}}
            expandable={{
              expandedRowRender: (record, index) => (
                <ExpandedRowTable indicators={record.indicators} categoryIndex={index} />
              ),
            }}
            expandedRowKeys={expandedRowKeys}
            onExpand={(expanded, record) => {
              const key = record.key;
              if (expanded) {
                setExpandedRowKeys([...expandedRowKeys, key]);
              } else {
                setExpandedRowKeys(expandedRowKeys.filter((k) => k !== key));
              }
            }}
            components={{
              body: {
                wrapper: DraggableCategoryBody,
                row: DraggableCategoryRow,
              },
            }}
          />
          <Drawer
            title="Table Order"
            placement="right"
            closable
            onClose={() => setDrawerVisible(false)}
            visible={drawerVisible}
            width={400}
          >
            <List
              dataSource={orderData}
              renderItem={(cat) => (
                <List.Item>
                  <div>
                    <strong>
                      {cat.order} {cat.categoryName} (Code: {cat.categoryCode})
                    </strong>
                    <List
                      size="small"
                      dataSource={cat.indicators}
                      renderItem={(ind) => (
                        <List.Item style={{ paddingLeft: 20 }}>
                          {ind.order} {ind.indicatorName} (Code: {ind.indicatorCode})
                        </List.Item>
                      )}
                    />
                  </div>
                </List.Item>
              )}
            />
          </Drawer>

          <Modal
        title="Select PDF Options"
        visible={pdfOptionsModalVisible}
        onCancel={() => {
          setPdfOptionsModalVisible(false);
          setIsCategoryReportMode(false);
        }}
        footer={null}
      >
        <Spin spinning={isLodingForGenerateAllTables || isCategoryReportLoading} tip={"This process may take time."}>
          <Form
            form={pdfOptionsForm}
            layout="vertical"
            initialValues={{ font_family: "Microsoft Sans Serif", text_alignment: "right" }}
            onFinish={(pdfOptions) => {
              const values = {...pdfOptions };
              if (isCategoryReportMode) {
                handleCategoryReportSubmit(values);
              } else {
                handleGenerateAllTables(values);
              }
            }}
          >
          <Form.Item
            name="font_family"
            label="Font Family"
            rules={[{ required: true, message: "Please select a font family" }]}
          >
            <Select placeholder="Select Font Family">
              <Option value="Microsoft Sans Serif">Microsoft Sans Serif</Option>
              <Option value="Arial">Arial</Option>
              <Option value="Calibri">Calibri Light</Option>
              <Option value="Times New Roman">Times New Roman</Option>
              <Option value="Courier New">Courier New</Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="text_alignment"
            label="Text Alignment"
            rules={[{ required: true, message: "Please select text alignment" }]}
          >
            <Select placeholder="Select Text Alignment">
              <Option value="left">Left</Option>
              <Option value="center">Center</Option>
              <Option value="right">Right</Option>
            </Select>
          </Form.Item>
          <Form.Item
        name="font_size"
        label="Font Size"
        rules={[{ required: false, message: "Please enter a font size" }]}
      >
        <InputNumber style={{ width: "100%" }} min={1} />
      </Form.Item>

      <Form.Item
        name="custom_table_number"
        label="Custom Table Number"
        rules={[{ required: false, message: "You can enter a custom table number" }]}
      >
        <Input placeholder="1.1, 1.2" />
      </Form.Item>

      <Form.Item
        name="custom_table_title"
        label="Custom Table Title"
        rules={[{ required: false, message: "You can enter a custom table title" }]}
      >
        <Input placeholder="Table x.x: Indicator Name" />
      </Form.Item>

      <Form.Item
        name="table_title_font_size"
        label="Table Title Font Size"
        rules={[{ required: false, message: "Please enter table title font size" }]}
      >
        <Input placeholder='10' />
      </Form.Item>

      <Form.Item
        name="header_height"
        label="Header Height"
        rules={[{ required: false, message: "Please enter header height" }]}
      >
        <InputNumber style={{ width: "100%" }} min={1} />
      </Form.Item>

      <Form.Item
        name="row_height"
        label="Row Height"
        rules={[{ required: false, message: "Please enter row height" }]}
      >
        <InputNumber style={{ width: "100%" }} min={1} />
      </Form.Item>

      <Form.Item
        name="header_fill_color"
        label="Header Fill Color (R,G,B)"
        rules={[{ required: false, message: "Please enter header fill color" }]}
      >
        <Input placeholder="e.g., 0,70,132" />
      </Form.Item>

      <Form.Item
        name="header_text_color"
        label="Header Text Color (R,G,B)"
        rules={[{ required: false, message: "Please enter header text color" }]}
      >
        <Input placeholder="e.g., 255,255,255" />
      </Form.Item>

      <Form.Item
        name="row_fill_color"
        label="Row Fill Color (R,G,B)"
        rules={[{ required: false, message: "Please enter row fill color" }]}
      >
        <Input placeholder="e.g., 217,225,242" />
      </Form.Item>

      <Form.Item
        name="bold_line_thickness"
        label="Bold Line Thickness"
        rules={[{ required: false, message: "Please enter bold line thickness" }]}
      >
        <InputNumber style={{ width: "100%" }} min={0.1} step={0.1} />
      </Form.Item>
          <Form.Item>
          <Button
          type="primary"
          htmlType="submit"
          onClick={() => setExportType('word')}
          style={{ marginRight: 8 }}
          disabled={false}
        >
          Export as Word
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          disabled={true}
          onClick={() => setExportType('pdf')}
        >
          Export as PDF
        </Button>
          </Form.Item>
        </Form>
        </Spin>
      </Modal>


          <Modal
            title="Preview PDF"
            visible={previewModalVisible}
            onCancel={() => setPreviewModalVisible(false)}
            footer={null}
            width={800}
          >
            <iframe
              src={previewUrl}
              style={{ width: '100%', height: '600px' }}
              title="PDF Preview"
            />
          </Modal>

          <CoverPageModal
            isCoverPageModalVisible={isCoverPageModalVisible}
            setIsCoverPageModalVisible={setIsCoverPageModalVisible}
            categories={categories}
            onFinish={handleGetCoverPage}
          />

          <PdfOptionsModal
            visible={generateWholeReportModalVisible}
            onCancel={() => setGenerateWholeReportModalVisible(false)}
            onSubmit={(values) => {
              setWholeReportRequest(values);
              handleGenerateWholeReport(values);
            }}
            loading={isLoadingForGenerateWholeReport}
          />



          <ScheduleReportModal
            visible={isScheduleModalVisible}
            onCancel={() => setIsScheduleModalVisible(false)}
            onSubmit={(values) => {
              handleGenerateWholeReportLater(values);
            }}
            loading={isLoadingForGenerateWholeReport}
          />

          
        </>
      )}
    </>
  );
}

export default GenerateReport;
